const MintControls = ({ mintAmount, onChange, price, totalPrice }) => {
    return (
        <div className="mb-6">
            <div className="block text-lg font-medium text-primary text-700 mb-2">
                <div>Mint Amount: {mintAmount}</div>
                {/* <div className="flex items-center mt-2 mb-4">
                    <span className="block text-lg font-medium custom-font text-700 mb-2">
                        Ξ{totalPrice}
                    </span>
                    {mintAmount > 1 && (
                        <span className="text-sm text-primary ml-2">
                            (Ξ{price} × {mintAmount})
                        </span>
                    )}
                </div> */}
            </div>
            <input
                id="slider"
                type="range"
                min="1"
                max="5"
                value={mintAmount}
                onChange={onChange}
                className="w-full h-2 bg-secondary rounded-lg appearance-none cursor-pointer focus:outline-none focus:ring-2 focus:ring-accent"
                style={{
                    background: `linear-gradient(to right, #576F72 ${((mintAmount - 1) / 4) * 100}%, #E4DCCF ${((mintAmount - 1) / 4) * 100}%)`
                }}
            />
        </div>
    );
};

export default MintControls;